import React from 'react';

import { WpRichTextInput } from 'Wpds/components/rich-text';
import { createFormField } from 'Shared/utils/createFormField';

type Props = {
  value?;
  autoFocus?: boolean;
  disabled?: boolean;
  placeholder?: string;
  onChange: Function;
  qaTest?: string;
};

function FormRichTextInput({
  value,
  autoFocus = false,
  disabled = false,
  onChange,
  placeholder = 'Enter text...',
  qaTest,
}: Props) {
  return (
    <WpRichTextInput
      value={value}
      onChange={onChange}
      autoFocus={autoFocus}
      disabled={disabled}
      placeholder={placeholder}
      qaTest={qaTest}
    />
  );
}

export default createFormField(FormRichTextInput);
